import Quill from 'quill';
import * as Emoji from 'quill2-emoji';

let registered = false;

export function registerQuillEmoji(): void {
  if (registered) return;
  Quill.register('modules/emoji', Emoji);
  registered = true;
}
